import React from "react";
import image_5 from "../../images/afro-academy/Picture10.png";
import image_6 from "../../images/afro-academy/Picture11.png";
import image_1 from "../../images/afro-academy/Picture6.png";
import image_2 from "../../images/afro-academy/Picture7.png";
import image_3 from "../../images/afro-academy/Picture8.png";
import image_4 from "../../images/afro-academy/Picture9.png";

const Services = () => {
  return (
    <section>
      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-water h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_1} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-maximum-blue-green h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">ustaze.com</p>
            <p className="gilroy-bold">Build Your Professional Career</p>
            <p>
              International market place for trainers everywhere to learn <br />{" "}
              and earn with their expertise and specialization.
            </p>
          </div>
        </div>
      </div>

      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-blanched-almond h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_2} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-american-yellow h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">faanei.com</p>
            <p className="gilroy-bold">Develop your Skills & Expertise </p>
            <p>
              Technician Vocational training where you can apply your <br />
              skills, your initiative and your ideas from day one.
            </p>
          </div>
        </div>
      </div>

      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-azureish-white h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_3} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-ultramarine-blue h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">handassa.com </p>
            <p className="gilroy-bold">Develop your Specialization</p>
            <p>
              Engineering specialist training targets professionals who <br />
              intend to become subject matter experts in their field.
            </p>
          </div>
        </div>
      </div>

      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-water h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_4} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-maximum-blue-green h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">mawaheba.com </p>
            <p className="gilroy-bold">Top Talents work with freedom </p>
            <p>
              Exclusive network of the top freelancers, digital Marketers <br />
              and remote workers.
            </p>
          </div>
        </div>
      </div>

      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-blanched-almond h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_5} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-american-yellow h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">tujaari.com </p>
            <p className="gilroy-bold">Launch your start-up </p>
            <p>
              Entrepreneurship & Ecommerce platform enables you to <br />{" "}
              acquire the essential skills to kickstart your own startup.
            </p>
          </div>
        </div>
      </div>

      <div className="row afro-service-card-height">
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 bg-azureish-white h-100 d-flex align-items-center justify-content-center">
          <div>
            <img src={image_6} className="img-fluid" loading="lazy" alt="" />
          </div>
        </div>
        <div className="col-md-6 col-xl-6 mb-2 mb-md-0 px-4 px-lg-0 py-2 py-lg-0 bg-ultramarine-blue h-100 d-flex align-items-center justify-content-center">
          <div className="fs-20">
            <p className="text-shadow">aamyr.com </p>
            <p className="gilroy-bold">Lead by best example </p>
            <p>
              Management & Leadership platform for high potential <br /> talents
              with career development and executive coaching.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
